import { render, staticRenderFns } from "./MatchScheduleCard.vue?vue&type=template&id=c5f1e3bc&scoped=true&"
import script from "./MatchScheduleCard.vue?vue&type=script&lang=js&"
export * from "./MatchScheduleCard.vue?vue&type=script&lang=js&"
import style0 from "./MatchScheduleCard.vue?vue&type=style&index=0&id=c5f1e3bc&lang=scss&scoped=true&"
import style1 from "./MatchScheduleCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f1e3bc",
  null
  
)

export default component.exports